<template>
  <div v-if="translations">
    <v-navigation-drawer
      app
      v-model="drawer"
      :fixed="$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      :permanent="$vuetify.breakpoint.mdAndUp"
      tag="header"
      color="white"
      class="header"
    >
      <div class="header__logo-wrapper">
        <button
          @click="toggleDrawer"
          id="menu-close-btn"
          class="header__close-btn hidden-md-and-up"
          aria-label="Close Menu"
        >
          <v-icon color="black">mdi-close</v-icon>
        </button>

        <v-img
          src="@/assets/images/logo.png"
          alt=""
          contain
          class="header__logo"
        />
      </div>

      <nav class="header__nav">
        <v-list nav dense>
          <v-list-item
            :to="{ name: 'home' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img src="@/assets/icons/home.svg" width="20px" contain />
            </v-list-item-icon>
            {{ translations.home.labels.home }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'infoandadvice' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/info-advice-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.infoAdvice }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'organisations' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/key-contacts-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.keyContacts }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'opportunity_categories' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/jobs-opportunities-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.jobsOpportunities }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'events' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img src="@/assets/icons/events-nav.svg" width="20px" contain />
            </v-list-item-icon>
            {{ translations.home.labels.events }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'offers_archive' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/discounts-offers-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.discountsOffers }}
          </v-list-item>
          
          <v-list-item
            :to="{ name: 'toolkit' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/mental-health-hub-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.mentalHealthHub }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'posts' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img src="@/assets/icons/posts-nav.svg" width="20px" contain />
            </v-list-item-icon>
            {{ translations.home.labels.posts }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'surveys' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/surveys-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.surveys }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'latest_news_archive' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/latest-news-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.latestNews }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'budget_planner' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/budget-planner-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.budgetPlanner }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'vips' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img src="@/assets/icons/vips-nav.svg" width="20px" contain />
            </v-list-item-icon>
            {{ translations.home.labels.vips }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'contact' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img
                src="@/assets/icons/get-in-touch-nav.svg"
                width="20px"
                contain
              />
            </v-list-item-icon>
            {{ translations.home.labels.getInTouch }}
          </v-list-item>

          <v-list-item
            :to="{ name: 'legal' }"
            exact
            class="header__nav-list-item"
          >
            <v-list-item-icon class="header__nav-icon">
              <v-img src="@/assets/icons/legal-nav.svg" width="20px" contain />
            </v-list-item-icon>
            {{ translations.home.labels.legal }}
          </v-list-item>

          <v-list-item
            class="header__nav-list-item header__nav-list-item--settings"
          >
            <Settings />
          </v-list-item>
        </v-list>
      </nav>

      <v-list nav dense class="header__actions-list">
        <v-list-item class="header__language-select settings_language-selector">
          <v-list-item-title class="header__language-select-title">
            <label for="languageSelect" class="header__language-select-label">
              {{ translations.settings.text.languages }}
            </label>
          </v-list-item-title>

          <v-select
            v-model="selectedLang"
            :items="langs"
            menu-props="auto"
            name="langs"
            prepend-icon-color="primary"
            item-text="name"
            item-value="code"
            solo
            flat
            hide-details
            background-color="pink"
            append-icon="mdi-chevron-down"
            color="black"
            id="languageSelect"
            @change="languageChangeHandler"
          >
          </v-select>
        </v-list-item>

        <v-list-item>
          <button
            type="button"
            @click="restartTheTour"
            class="header__tour-btn"
          >
            {{ translations.tutorial.startTutorial }}
          </button>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app class="toolbar" light tag="div" flat height="70px">
      <div class="toolbar__background-wrapper">
        <button
          @click="toggleDrawer"
          id="menu-btn"
          class="toolbar__btn hidden-md-and-up"
          aria-label="Menu"
        >
          <svg
            width="35"
            height="25"
            viewBox="0 0 35 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M35 1.25C35 1.58152 34.8683 1.89946 34.6339 2.13388C34.3995 2.3683 34.0815 2.5 33.75 2.5H1.25C0.918479 2.5 0.600537 2.3683 0.366116 2.13388C0.131696 1.89946 0 1.58152 0 1.25C0 0.918479 0.131696 0.600537 0.366116 0.366117C0.600537 0.131696 0.918479 0 1.25 0H33.75C34.0815 0 34.3995 0.131696 34.6339 0.366117C34.8683 0.600537 35 0.918479 35 1.25ZM28.75 11.25H1.25C0.918479 11.25 0.600537 11.3817 0.366116 11.6161C0.131696 11.8505 0 12.1685 0 12.5C0 12.8315 0.131696 13.1495 0.366116 13.3839C0.600537 13.6183 0.918479 13.75 1.25 13.75H28.75C29.0815 13.75 29.3995 13.6183 29.6339 13.3839C29.8683 13.1495 30 12.8315 30 12.5C30 12.1685 29.8683 11.8505 29.6339 11.6161C29.3995 11.3817 29.0815 11.25 28.75 11.25ZM17.5 22.5H1.25C0.918479 22.5 0.600537 22.6317 0.366116 22.8661C0.131696 23.1005 0 23.4185 0 23.75C0 24.0815 0.131696 24.3995 0.366116 24.6339C0.600537 24.8683 0.918479 25 1.25 25H17.5C17.8315 25 18.1495 24.8683 18.3839 24.6339C18.6183 24.3995 18.75 24.0815 18.75 23.75C18.75 23.4185 18.6183 23.1005 18.3839 22.8661C18.1495 22.6317 17.8315 22.5 17.5 22.5Z"
              fill="black"
            />
          </svg>
        </button>

        <button
          v-if="$route.name !== 'home'"
          class="toolbar__btn"
          :aria-label="translations.tutorial.buttons.back"
          @click="$router.go(-1)"
        >
          <svg
            width="14"
            height="25"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7853 0.26135C12.1338 -0.0871167 12.6988 -0.0871167 13.0472 0.26135C13.3957 0.609826 13.3957 1.1748 13.0472 1.52325L2.07068 12.4998L13.0476 23.4767C13.3961 23.8252 13.3961 24.3902 13.0476 24.7386C12.6991 25.0871 12.1341 25.0871 11.7857 24.7386L0.261734 13.2147C0.0666756 13.0196 -0.0191945 12.7567 0.0040947 12.502C-0.0204437 12.246 0.0653071 11.9814 0.261347 11.7853L11.7853 0.26135Z"
              fill="black"
            />
          </svg>
        </button>

        <v-spacer></v-spacer>

        <RouterLink :to="{ name: 'home' }" class="toolbar__btn">
          <span class="sr-only">{{ translations.home.labels.home }}</span>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.6942 24.9969H7.30481C6.1299 25.0406 4.98522 24.6188 4.1195 23.8233C3.25378 23.0278 2.73696 21.9227 2.68134 20.7483V15.1787C2.68134 14.942 2.77538 14.715 2.94276 14.5476C3.11015 14.3802 3.33718 14.2862 3.5739 14.2862C3.81062 14.2862 4.03765 14.3802 4.20504 14.5476C4.37243 14.715 4.46646 14.942 4.46646 15.1787V20.7483C4.52132 21.4494 4.84976 22.1007 5.38084 22.5617C5.91192 23.0226 6.603 23.2561 7.30481 23.2118H17.6942C18.396 23.2561 19.0871 23.0226 19.6182 22.5617C20.1493 22.1007 20.4777 21.4494 20.5326 20.7483V15.1787C20.5326 14.942 20.6266 14.715 20.794 14.5476C20.9614 14.3802 21.1884 14.2862 21.4251 14.2862C21.6619 14.2862 21.8889 14.3802 22.0563 14.5476C22.2237 14.715 22.3177 14.942 22.3177 15.1787V20.7483C22.2621 21.9227 21.7453 23.0278 20.8795 23.8233C20.0138 24.6188 18.8692 25.0406 17.6942 24.9969ZM24.7366 13.1348C24.8202 13.0518 24.8866 12.9531 24.9319 12.8443C24.9772 12.7355 25.0006 12.6189 25.0006 12.501C25.0006 12.3832 24.9772 12.2666 24.9319 12.1578C24.8866 12.049 24.8202 11.9503 24.7366 11.8673L13.1332 0.264018C13.0503 0.18036 12.9516 0.113958 12.8428 0.0686442C12.734 0.02333 12.6174 0 12.4995 0C12.3817 0 12.265 0.02333 12.1563 0.0686442C12.0475 0.113958 11.9488 0.18036 11.8658 0.264018L0.262495 11.8673C0.0944223 12.0354 0 12.2634 0 12.501C0 12.7387 0.0944223 12.9667 0.262495 13.1348C0.430568 13.3028 0.658523 13.3973 0.896214 13.3973C1.13391 13.3973 1.36186 13.3028 1.52993 13.1348L12.4995 2.15625L23.4691 13.1348C23.5521 13.2184 23.6508 13.2848 23.7596 13.3301C23.8683 13.3755 23.985 13.3988 24.1028 13.3988C24.2207 13.3988 24.3373 13.3755 24.4461 13.3301C24.5549 13.2848 24.6536 13.2184 24.7366 13.1348Z"
              fill="black"
            />
          </svg>
        </RouterLink>

        <RouterLink
          aria-label="Open Favourites page"
          :to="{ name: 'favourites' }"
          id="favourites-btn"
          class="toolbar__btn"
        >
          <span class="sr-only">Open Favourites page</span>
          <v-badge
            v-if="favouritesCount > 0"
            :content="favouritesCount"
            color="black"
            overlap
            dark
          >
            <svg
              width="29"
              height="27"
              viewBox="0 0 29 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.2227 6.91571C27.7844 4.6551 26.5339 2.97701 24.5138 1.92953C23.5518 1.43252 22.4936 1.13859 21.2698 1.0317C19.8963 0.908783 18.6297 1.14393 17.5021 1.72645C16.3531 2.31432 15.4232 3.19612 14.6643 4.41461C14.6002 4.31307 14.5361 4.21687 14.4719 4.11533C13.1786 2.22881 11.3616 1.19737 9.06355 1.03705C8.43293 0.994291 7.79697 1.02101 7.17169 1.11721C5.75547 1.33632 4.54233 1.87609 3.56433 2.72048C2.04122 4.04051 1.19149 5.83617 1.02047 8.05938C0.940306 9.12823 1.09529 10.2238 1.49076 11.4156C1.88624 12.6073 2.48479 13.7724 3.32918 15.0069C4.36062 16.5247 5.65393 18.0264 7.4015 19.7472C8.82841 21.1528 10.4691 22.6011 12.5533 24.3112C13.0023 24.68 13.4512 25.0434 13.9001 25.4068L14.6323 26L14.8995 25.8236C14.9102 25.813 14.9262 25.8076 14.9369 25.7969L14.9743 25.7702L14.9957 25.7542C17.299 24.0333 19.2497 22.4194 20.9491 20.8214C22.7395 19.1433 24.1129 17.6309 25.278 16.0597C26.4217 14.5152 27.1966 13.1364 27.7203 11.7202C28.3509 10.0047 28.5166 8.43348 28.2227 6.91571ZM14.3009 5.49414L14.659 6.07667L15.0384 5.51018C15.0438 5.49949 15.0491 5.4888 15.0545 5.47811L15.0598 5.46208C15.0865 5.41398 15.1186 5.36054 15.1453 5.31244C15.2041 5.20555 15.2682 5.09333 15.3324 4.98644C16.0218 3.84812 16.8555 3.03045 17.8976 2.50137C18.8916 1.98832 19.9712 1.79593 21.1896 1.90281C22.2959 1.99901 23.2525 2.26622 24.1076 2.70979C25.8765 3.629 26.9721 5.09867 27.3569 7.08673C27.6188 8.43882 27.4691 9.86039 26.8919 11.4209C26.4003 12.7623 25.6628 14.0717 24.5672 15.5467C23.4342 17.0698 22.0928 18.5448 20.3452 20.1908C18.7153 21.7193 16.8555 23.2638 14.6643 24.9098L14.4399 24.7281C13.9909 24.3647 13.542 23.9959 13.0931 23.6325C11.0302 21.9437 9.41093 20.5061 8.00005 19.122C6.30593 17.4439 5.04468 15.9849 4.04531 14.5152C3.24902 13.3448 2.68253 12.2386 2.31378 11.1377C1.95571 10.0635 1.81676 9.07479 1.88624 8.12885C2.04122 6.11407 2.77338 4.56424 4.12547 3.38851C4.99124 2.64032 6.02268 2.18071 7.29461 1.98832C7.68474 1.92953 8.08021 1.89747 8.47569 1.89747C8.65205 1.89747 8.82306 1.90281 8.99408 1.9135C11.0409 2.05245 12.5961 2.9396 13.7451 4.61234C13.8787 4.80474 13.9963 5.00247 14.1246 5.21624C14.1833 5.30709 14.2421 5.40329 14.3009 5.49414Z"
                fill="black"
                stroke="black"
              />
            </svg>
          </v-badge>
          <svg
            v-else
            width="29"
            height="27"
            viewBox="0 0 29 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.2227 6.91571C27.7844 4.6551 26.5339 2.97701 24.5138 1.92953C23.5518 1.43252 22.4936 1.13859 21.2698 1.0317C19.8963 0.908783 18.6297 1.14393 17.5021 1.72645C16.3531 2.31432 15.4232 3.19612 14.6643 4.41461C14.6002 4.31307 14.5361 4.21687 14.4719 4.11533C13.1786 2.22881 11.3616 1.19737 9.06355 1.03705C8.43293 0.994291 7.79697 1.02101 7.17169 1.11721C5.75547 1.33632 4.54233 1.87609 3.56433 2.72048C2.04122 4.04051 1.19149 5.83617 1.02047 8.05938C0.940306 9.12823 1.09529 10.2238 1.49076 11.4156C1.88624 12.6073 2.48479 13.7724 3.32918 15.0069C4.36062 16.5247 5.65393 18.0264 7.4015 19.7472C8.82841 21.1528 10.4691 22.6011 12.5533 24.3112C13.0023 24.68 13.4512 25.0434 13.9001 25.4068L14.6323 26L14.8995 25.8236C14.9102 25.813 14.9262 25.8076 14.9369 25.7969L14.9743 25.7702L14.9957 25.7542C17.299 24.0333 19.2497 22.4194 20.9491 20.8214C22.7395 19.1433 24.1129 17.6309 25.278 16.0597C26.4217 14.5152 27.1966 13.1364 27.7203 11.7202C28.3509 10.0047 28.5166 8.43348 28.2227 6.91571ZM14.3009 5.49414L14.659 6.07667L15.0384 5.51018C15.0438 5.49949 15.0491 5.4888 15.0545 5.47811L15.0598 5.46208C15.0865 5.41398 15.1186 5.36054 15.1453 5.31244C15.2041 5.20555 15.2682 5.09333 15.3324 4.98644C16.0218 3.84812 16.8555 3.03045 17.8976 2.50137C18.8916 1.98832 19.9712 1.79593 21.1896 1.90281C22.2959 1.99901 23.2525 2.26622 24.1076 2.70979C25.8765 3.629 26.9721 5.09867 27.3569 7.08673C27.6188 8.43882 27.4691 9.86039 26.8919 11.4209C26.4003 12.7623 25.6628 14.0717 24.5672 15.5467C23.4342 17.0698 22.0928 18.5448 20.3452 20.1908C18.7153 21.7193 16.8555 23.2638 14.6643 24.9098L14.4399 24.7281C13.9909 24.3647 13.542 23.9959 13.0931 23.6325C11.0302 21.9437 9.41093 20.5061 8.00005 19.122C6.30593 17.4439 5.04468 15.9849 4.04531 14.5152C3.24902 13.3448 2.68253 12.2386 2.31378 11.1377C1.95571 10.0635 1.81676 9.07479 1.88624 8.12885C2.04122 6.11407 2.77338 4.56424 4.12547 3.38851C4.99124 2.64032 6.02268 2.18071 7.29461 1.98832C7.68474 1.92953 8.08021 1.89747 8.47569 1.89747C8.65205 1.89747 8.82306 1.90281 8.99408 1.9135C11.0409 2.05245 12.5961 2.9396 13.7451 4.61234C13.8787 4.80474 13.9963 5.00247 14.1246 5.21624C14.1833 5.30709 14.2421 5.40329 14.3009 5.49414Z"
              fill="black"
              stroke="black"
            />
          </svg>
        </RouterLink>

        <RouterLink
          aria-label="Open Search page"
          :to="{ name: 'search' }"
          class="toolbar__btn"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.7511 23.5265L17.9991 16.7744C17.9987 16.774 17.9987 16.7734 17.9991 16.7731C19.4444 15.0685 20.2842 12.9331 20.3874 10.7006C20.6779 4.65234 15.8649 -0.216219 9.81378 0.0074075C4.4837 0.209155 0.209152 4.48371 0.00740426 9.81378C-0.216174 15.865 4.65244 20.678 10.7008 20.3872C12.9331 20.284 15.0684 19.4442 16.773 17.999C16.7734 17.9987 16.774 17.9987 16.7743 17.999L23.5265 24.7511C23.8673 25.0866 24.4156 25.0824 24.7511 24.7416C25.083 24.4045 25.083 23.8635 24.7511 23.5265ZM1.95197 12.1642C1.28724 9.19701 2.15552 6.26862 4.21212 4.21207C6.26871 2.15553 9.19701 1.28719 12.1643 1.95197C14.9717 2.58109 17.8182 5.42734 18.4474 8.23443C19.1125 11.202 18.2441 14.1307 16.1874 16.1874C14.1307 18.2441 11.2018 19.1125 8.23428 18.4473C5.42719 17.8181 2.58109 14.9714 1.95197 12.1642Z"
              fill="black"
            />
          </svg>
        </RouterLink>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import Settings from "@/components/Header/Settings.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Settings,
  },
  name: "Header",
  data: () => ({
    drawer: false,
    selectedLang: localStorage.getItem("current_lang"),
    loading: false,
    alert: false,
    dialog: false,
    fontAlert: false,
    langs: [
      { name: "English", code: "en" },
      { name: "Arabic | عربي", code: "ar" },
      { name: "Kurdish (Sorani) | کوردی", code: "ckb" },
      { name: "Polish | Polski", code: "pl" },
      { name: "Portuguese | Português", code: "pt-PT" },
      { name: "Pashto | پښتو", code: "ps" },
      { name: "Vietnamese | Tiếng Việt", code: "vi" },
    ],
  }),
  mounted() {
    /// listening for language change emit coming form settings.vue
    /// we're passing the 'language' and then setting is as a selected one
    this.$bus.$on("language-changed-from-settings-page", (language) => {
      this.selectedLang = language;
    });
  },
  beforeDestroy() {
    // stop listening for the emit coming from settings.vue
    this.$bus.$off("language-changed-from-settings-page");
  },
  methods: {
    ...mapActions("user", ["logoutUser"]),
    ...mapActions("hubbdata", ["updateLang", "initDB"]),
    restartTheTour() {
      this.drawer = !this.drawer;
      localStorage.removeItem("has_seen_the_tour");

      if (this.$route.name === "home") {
        this.startTour();
      } else {
        this.$router.push({ name: "home" }).then(() => {
          this.startTour();
        });
      }
    },
    startTour() {
      this.$tours["myTour"].start();
    },
    signOut() {
      this.$store.dispatch("signOut").then(() => {
        this.$router.push({ name: "user_sign_in" });
      });
    },
    toggleDrawer() {
      this.drawer = !this.drawer;

      setTimeout(selectMenuItem, 100);
      function selectMenuItem() {
        if (document.getElementsByClassName("v-list-item--active").length) {
          document.getElementsByClassName("v-list-item--active")[0].focus();
        } else {
          document.getElementsByClassName("header__close-btn")[0].focus();
        }
      }
    },
    loadingSpinner() {
      this.loading = !this.loading;
    },
    languageChangeHandler() {
      this.loadingSpinner();

      this.updateLang(this.selectedLang).then(() => {
        this.initDB().then(() => {});
      });
      this.alert = true;
      // send a global emit back to Settings.vue with the newly selected language
      this.$bus.emit("language-changed-from-header", this.selectedLang);
    },
    DismissAlert() {
      this.alert = false;
    },
    DismissFontAlert() {
      this.fontAlert = false;
    },
    logoutBtnClickHandler() {
      this.logoutUser().then(() => {
        this.$router.push({ name: "sign_in" });
      });
    },
  },
  computed: {
    ...mapGetters("hubbdata", ["translations"]),
    ...mapGetters("favourites", ["favouritesCount"]),
    ...mapGetters("user", ["isTokenSet", "totalUnreadMessages", "userData"]),
    currentUser() {
      return this.$store.state.user;
    },
    currentLang() {
      let dictionary = {
        en: "English",
        ar: "Arabic",
        zh: "Chinese",
        fr: "French",
        pl: "Polish",
        so: "Somali",
        es: "Spanish",
        vi: "Vietnamese",
      };

      return dictionary[this.selectedLang];
    },
    userAvatar() {
      return {
        avatar_fallback: "#eeeeee",
        image_url: this.userData.image_url,
        display_name: this.userData.display_name,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  height: auto !important;
  z-index: 11 !important;
  background-color: transparent !important;
  transition: background-color 0.5s;
  padding: var(--sat) 0 0 var(--sal);

  &.v-app-bar--is-scrolled {
    background-color: $white !important;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;

    .toolbar__background-wrapper {
      background-color: rgba(255, 255, 255, 0);
    }
  }

  &__background-wrapper {
    display: flex;
    align-items: center;
    column-gap: 10px;
    padding: 12px 15px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100px;
    transition: background-color 0.5s;
  }

  &__back-btn {
    font-size: 1.125rem;
    font-weight: 400;
    color: $black !important;
    text-transform: unset !important;
  }

  &__btn {
    font-size: 0;
    border-radius: 4px;
    width: auto !important;
    height: auto !important;

    &:focus {
      outline: 2px solid $black;
      outline-offset: 3px;
    }
  }

  ::v-deep {
    .v-toolbar__content {
      padding-left: 16px;
      padding-right: 16px;

      @media (min-width: 360px) {
        padding-left: 24px;
        padding-right: 24px;
      }
    }
  }
}

.header {
  width: calc(256px + var(--sal)) !important;
  background-color: $black !important;
  z-index: 13 !important;

  &__close-btn {
    position: absolute;
    top: calc(var(--sat) + 6px);
    right: 6px;
    border-radius: 4px;

    &:focus {
      outline: 2px solid $black;
    }
  }

  &__logo-wrapper {
    position: relative;
    background: $white;
    padding: calc(var(--sat) + 20px) 16px 20px calc(var(--sal) + 16px);;
    border-bottom: 4px solid $black;
    display: flex;
    flex-shrink: 0;
  }

  &__logo {
    margin: auto;
    max-width: 170px !important;
  }

  &__nav {
    margin-bottom: auto;
    margin-top: 20px;
    padding-bottom: var(--sab);
    padding-left: var(--sal);
  }

  &__nav-list-item {
    font-size: 1rem;
    line-height: 1.3;
    font-weight: 600;
    color: $white !important;
    word-break: break-word;

    &--settings {
      padding: 0 !important;
    }

    &:focus {
      outline: 2px solid $white;
    }
  }

  &__nav-icon {
    margin-right: 10px !important;
    margin-left: 0 !important;

    .v-image {
      flex: unset !important;
    }
  }

  &__actions-list {
    padding: 0 0 var(--sab) var(--sal);
    margin-bottom: 12px;

    .v-list-item {
      min-height: unset !important;
    }
  }

  &__language-select {
    flex-direction: column;
    min-height: unset;
    margin-bottom: 20px !important;
    margin-top: 20px;

    ::v-deep {
      .v-input {
        border-radius: 10px;

        &__control {
          min-height: 40px;
        }

        &.v-input--is-focused {
          outline: 2px solid $white;
          outline-offset: 2px;
        }

        .v-select__selection {
          font-size: 1rem !important;
          font-weight: 600;
        }

        .v-icon {
          color: $black !important;
        }
      }
    }
  }

  &__language-select-title {
    display: block;
    width: 100%;
  }

  &__language-select-label {
    display: block;
    width: 100%;
    margin-bottom: 5px;
    color: $white;
  }

  &__tour-btn {
    display: block;
    width: 100%;
    border-radius: 100px;
    background-color: $green;
    font-size: 1rem;
    line-height: 1.3;
    color: $black;
    text-align: center;
    min-height: 36px;
    padding: 5px 10px;

    &:focus {
      outline: 2px solid $white;
      outline-offset: 2px;
    }
  }

  &__logout-btn {
    display: block;
    width: 100%;
    border-radius: 100px;
    background-color: $blue;
    font-size: 1rem;
    line-height: 1.3;
    color: $black;
    text-align: center;
    min-height: 36px;
    padding: 5px 10px;

    &:focus {
      outline: 2px solid $white;
      outline-offset: 2px;
    }
  }

  ::v-deep {
    .v-navigation-drawer__content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
